export default __webpack_public_path__ + "static/logo-fb3c92eb7ae63cd99ba112babd606d4c.png";